import * as React from "react";

import {AsyncQueue}     from "@Common/react/async-queue/async-queue";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

export const CheckoutStore = ({cart, disableQueue, next}) => cs(
    consumeContext("cart"),
    ["queue", ({cart: rootCart}, next) => AsyncQueue({
        data: cart,
        onUpdated: (newCart) => {
            if (rootCart.value && newCart.cartId === rootCart.value.cartId) {
                rootCart.onChange(newCart);
            }
        },
        disabled: disableQueue,
        next,
    })],

    ({queue}) => next({
        cart: cart.value,
        loading: queue.active, // Deprecated, use saving
        saving: queue.active,
        dispatch: queue.pushAction,
    }),
);

